import { FunctionComponent } from 'react';
import classnames from 'classnames';

import { SIZES } from '../constants';

import styles from './TextInputContainer.scss';

type TextInputContainerProps = {
    paddingTop?: typeof SIZES.none | typeof SIZES.animatedPlaceholder;
    usePaddingLeft?: boolean;
    isTextInputUppercased?: boolean;
    isFocused?: boolean;
};

export const TextInputContainer: FunctionComponent<TextInputContainerProps> = ({
    children,
    paddingTop,
    usePaddingLeft,
    isTextInputUppercased,
    isFocused,
}) => {
    const className = classnames(styles.textInputWrapper, {
        [styles.animatedPlaceholderPadding]: paddingTop === SIZES.animatedPlaceholder,
        [styles.usePaddingLeft]: usePaddingLeft,
        [styles.uppercased]: isTextInputUppercased,
        [styles.isFocused]: isFocused,
    });
    return <div className={className}>{children}</div>;
};
